module.exports = __webpack_public_path__ + "img/20200713-3.22c4e086.png";